<template>
<div>
    <v-overlay :value="overlay">
      <div class="centralizado">
      <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
      <br>
      <br>
      <p>Enviando arquivo, Aguarde um momento</p>
      </div>
    </v-overlay>

<div v-if="mostraDocumento">
  <meu-painel>
    
    <div class="mostraArquivo">
      <h1 v-if="!file">Insira um arquivo!</h1>
      <img v-if="URL && (tipoEnvio === 1 || tipoEnvio === 2)" :src="URL" width="100%" height="100%" />
      <object
        v-if="URL && tipoEnvio === 0"
        :data="URL"
        type="application/pdf"
        width="100%"
        height="400px"
        border="none"
        frameborder="0"
      >
        <p>
          Seu navegador ou celular não possui o plugin de visualizar PDF. Ao inves disso, você pode
          <a
            :href="URL"
          >
            clicar aqui para
            baixar o arquivo PDF.
          </a> e visualizar
        </p>
      </object>
    </div>
    <div>
      <br />
      <router-link :to="{ name: 'uploadDoc'}">Enviar outro arquivo</router-link>
      <br />
      <v-checkbox v-model="checkbox" label="Confirma Envio?"></v-checkbox>
      <v-btn
        v-on:click="dadosProdutor.tax_id ? submitFileLogin() : submitFileApi()"
        :disabled="!checkbox || !file"
        color="primary"
      >Confirmar</v-btn>
    </div>
    <br />
    <br />
    <br>
    <div class="centralizado">
    <p v-if="mostraErro" style="font-size: 30px">{{erroEnvio}}</p>
    </div>
  </meu-painel>
  </div>
</div>
</template>

<script>
import Painel from "../components/Painel.vue";
import api from "../services/api";

export default {
  components: {
    "meu-painel": Painel
  },

  data() {
    return {
      file: [],
      dadosProdutor: {},
      tipoEnvio: "",
      checkbox: false,
      URL: null,
      uploadPercentage: 0,
      erroEnvio: "Erro, Tente enviar Novamente",
      mostraErro: false,
      overlay: false,
      mostraDocumento: true,
    };
  },

  mounted() {
    const produtor = localStorage.getItem("produtor");
    this.dadosProdutor = JSON.parse(produtor);

    this.file = this.$router.currentRoute.params.file;
    this.tipoEnvio = this.$router.currentRoute.params.tipoEnvio;

    this.URL = this.definirUrl();
  },

  methods: {
    definirUrl() {
      return this.tipoEnvio === 0
        ? URL.createObjectURL(this.file) +
            "#toolbar=0&navpanes=0&scrollbar=0&transparent=0"
        : URL.createObjectURL(this.file);
    },
    submitFileApi() {
      this.overlay = true;
      this.mostraDocumento = false;
      const formData = new FormData();

      formData.append("producer_id", this.dadosProdutor.producer_id);
      formData.append("producer_name", this.dadosProdutor.producer_name);
      formData.append("producer_tax_id", this.dadosProdutor.producer_tax_id);
      formData.append("requester_id", this.dadosProdutor.requester_id);
      formData.append("requester_name", this.dadosProdutor.requester_name);
      formData.append("requester_company_id", this.dadosProdutor.requester_company_id);
      formData.append(
        "requester_company",
        this.dadosProdutor.requester_company
      );
      formData.append("requester_company_tax_id", this.dadosProdutor.requester_company_tax_id);

      formData.append("method", this.tipoEnvio + 1);
      formData.append("file", this.file);
      

      api
        .post("/scr-auth-api", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },

          onUploadProgress: function(progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this)
        })
        .then(() => {
          this.$router.push({ name: "final" });
        })
        .catch(err => {
          this.overlay = false;
          this.mostraDocumento = true;
          this.mostraErro = true;
          this.uploadPercentage = 0;
        });
    },
    submitFileLogin() {

      this.overlay = true;
      this.mostraDocumento = false;

      const formData = new FormData();

      formData.append("client_id", this.dadosProdutor._id);
      formData.append("requester_id", this.dadosProdutor.user_id);

      formData.append("method", this.tipoEnvio + 1);
      formData.append("file", this.file);

      api
        .post("/scr-auth", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          },

          onUploadProgress: function(progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this)
        })
        .then(() => {
          this.$router.push({ name: "final" });
        })
        .catch(err => {
          this.overlay = false;
          this.mostraDocumento = true;
          this.mostraErro = true;
          this.uploadPercentage = 0;
        });
    }
  }
};
</script>

<style>
.mostraArquivo {
  width: 100%;
  height: 100%;
}

.centralizado {
  text-align: center;
}
</style>